import { period2PeriodStore } from '@stores/dictionaryStores/period2PeriodStore';

import { controlApplicabilityStore } from './controlApplicabilityStore/controlApplicabilityStore';
import { controlGroupsStore } from './controlGroupsStore/controlGroupsStore';
import { controlsStore } from './controlsStore/controlsStore';
import { controlVersionsStore } from './controlVersionsStore/controlVersionsStore';
import { counterpartiesStore } from './counterpartiesStore/counterpartiesStore';
import { counterpartyTypesStore } from './counterpartyTypesStore';
import { filterOperatorsStore } from './filterOperatorsStore';
import { frequenciesStore } from './frequenciesStore';
import { indicatorsStore } from './indicatorsStore/indicatorsStore';
import { infoSystemsStore } from './infoSystemStore';
import { monthsStore } from './monthsStore';
import { organizationsStore } from './organizationsStore';
import { organizationTypeStore } from './organizationTypeStore';
import { orgBusinessTypesStore } from './orgBusinessTypesStore';
import { periodsStore } from './periodsStore';
import { reportGroupsStore } from './reportGroupsStore/reportGroupsStore';
import { reportPeriodsStore } from './reportPeriodsStore';
import { reportsStore } from './reports/reportsStore';
import { reportTypesStore } from './reportTypes';
import { reportVersionsStore } from './reportVersion/reportVersionsStore';
import { roundTypeStore } from './roundTypeStore';
import { sourceTypesStore } from './sourceTypesStore';
import { stepTypesStore } from './stepTypesStore';

// isChanged нужен для редактируемых справочниках
function fetchIfEmpty(fetch: () => void, items: Array<unknown>, isChanged = false) {
  if (!items.length || isChanged) {
    fetch();
  }
}

type Reference =
  | 'organizations'
  | 'periods'
  | 'reportGroups'
  | 'reportPeriods'
  | 'reports'
  | 'reportTypes'
  | 'controls'
  | 'organizationTypes'
  | 'months'
  | 'frequencies'
  | 'reportVersions'
  | 'infoSystems'
  | 'sourceTypes'
  | 'stepTypes'
  | 'controlVersions'
  | 'indicators'
  | 'filterOperators'
  | 'controlApplicability'
  | 'controlGroups'
  | 'organizationBusinessTypes'
  | 'counterparties'
  | 'counterpartyTypes'
  | 'roundTypes'
  | 'period2Period';

type ReferenceFetch = {
  [key in Reference]: () => void;
};

const referenceFetch: ReferenceFetch = {
  organizations: () =>
    fetchIfEmpty(organizationsStore.fetch, organizationsStore.organizations, organizationsStore.isChanged),
  periods: () => fetchIfEmpty(periodsStore.fetch, periodsStore.periods),
  reportGroups: () =>
    fetchIfEmpty(reportGroupsStore.fetch, reportGroupsStore.reportGroups, reportGroupsStore.isChanged),
  months: () => fetchIfEmpty(monthsStore.fetch, monthsStore.months),
  frequencies: () => fetchIfEmpty(frequenciesStore.fetch, frequenciesStore.frequencies),
  reports: () => fetchIfEmpty(reportsStore.fetch, reportsStore.reports, reportsStore.isChanged),
  reportVersions: () =>
    fetchIfEmpty(reportVersionsStore.fetch, reportVersionsStore.reportVersions, reportVersionsStore.isChanged),
  controls: () => fetchIfEmpty(controlsStore.fetch, controlsStore.controls, controlsStore.isChanged),
  infoSystems: () => fetchIfEmpty(infoSystemsStore.fetch, infoSystemsStore.infoSystems),
  sourceTypes: () => fetchIfEmpty(sourceTypesStore.fetch, sourceTypesStore.sourceTypes),
  organizationTypes: () => fetchIfEmpty(organizationTypeStore.fetch, organizationTypeStore.orgTypes),
  reportTypes: () => fetchIfEmpty(reportTypesStore.fetch, reportTypesStore.reportTypes, reportTypesStore.isChanged),
  reportPeriods: () =>
    fetchIfEmpty(reportPeriodsStore.fetch, reportPeriodsStore.reportPeriods, reportPeriodsStore.isChanged),
  stepTypes: () => fetchIfEmpty(stepTypesStore.fetch, stepTypesStore.stepTypes),
  controlVersions: () =>
    fetchIfEmpty(controlVersionsStore.fetch, controlVersionsStore.controlVersions, controlVersionsStore.isChanged),
  indicators: () => fetchIfEmpty(indicatorsStore.fetch, indicatorsStore.indicators, indicatorsStore.isChanged),
  controlApplicability: () =>
    fetchIfEmpty(
      controlApplicabilityStore.fetch,
      controlApplicabilityStore.controlApplicability,
      controlApplicabilityStore.isChanged,
    ),
  filterOperators: () => fetchIfEmpty(filterOperatorsStore.fetch, filterOperatorsStore.filterOperators),
  controlGroups: () =>
    fetchIfEmpty(controlGroupsStore.fetch, controlGroupsStore.controlGroups, controlGroupsStore.isChanged),
  organizationBusinessTypes: () => fetchIfEmpty(orgBusinessTypesStore.fetch, orgBusinessTypesStore.orgBusinessTypes),
  counterparties: () => fetchIfEmpty(counterpartiesStore.fetch, counterpartiesStore.counterparties),
  counterpartyTypes: () => fetchIfEmpty(counterpartyTypesStore.fetch, counterpartyTypesStore.counterpartyTypes),
  roundTypes: () => fetchIfEmpty(roundTypeStore.fetch, roundTypeStore.roundTypes),
  period2Period: () => fetchIfEmpty(period2PeriodStore.fetch, period2PeriodStore.period2period),
};

export function fetchReferences(references?: Reference[]): void {
  references?.forEach((reference) => referenceFetch[reference]());
}

export function isChangedAllReference(): void {
  organizationsStore.setIsChanged();
  reportGroupsStore.setIsChanged(true);
  reportsStore.setIsChanged(true);
  reportVersionsStore.setIsChanged(true);
  controlsStore.setIsChanged(true);
  reportTypesStore.setIsChanged(true);
  reportPeriodsStore.setIsChanged(true);
  controlVersionsStore.setIsChanged(true);
  indicatorsStore.setIsChanged(true);
  controlApplicabilityStore.setIsChanged(true);
  controlGroupsStore.setIsChanged(true);
}
